<script setup lang="ts">
import { ref, watch } from "vue";
import { appStore } from "../stores/app";

// The list opens whenever the errors change (and closes when there are none);
// the warning button toggles it.
const isOpen = ref(false);
watch(() => [...appStore.errors], errors => { isOpen.value = errors.length > 0; });
</script>

<template>
    <div class="errors bulma-contextual" :class="{ 'is-active': appStore.errors.length > 0 }">
        <a href="#" class="errors__button" @click.prevent="isOpen = !isOpen">
            <i class="fas fa-exclamation-triangle fa-2x"></i>
        </a>
        <ul class="errors__items" :class="{ 'is-active': isOpen }">
            <!-- Messages are our own translated texts with product names, which may contain markup -->
            <li v-for="error in appStore.errors" :key="error" class="errors__items__item notification" v-html="error"></li>
        </ul>
    </div>
</template>
